export const SET_TABLE_COLUMN_VISIBILITY = 'table/SET_TABLE_COLUMN_VISIBILITY';
